import { gql } from '@apollo/client';

export const MatchingCriterionNeed = gql`
    fragment MatchingCriterionNeed on MatchingCriterionAssignment {
        id
        criterion {
            id
            displayName
            description
            modality
        }
    }
`;
